import LiveCaller from '@/LiveCaller'

// Standalone version of the global `__()` mixin for use in setup()/composables,
// where there is no component instance. Same lookup, same fallback-to-key.
export function translate(key, replace = {}) {
    const locale = LiveCaller.config.get('app.locale')
    let translation = LiveCaller.translations?.[locale]?.[key] ?? key
    Object.entries(replace).forEach(([name, value]) => {
        translation = translation.replace(`:${name}`, value)
    })
    return translation
}
